import { Icon } from "@powerhousedao/design-system";
import { twMerge } from "tailwind-merge";
import {
  ConnectDropdownMenu,
  fileNodeDropdownOptions,
} from "@powerhousedao/design-system/connect";
import type { FileNode } from "@powerhousedao/shared/document-drive";
import React, { useState } from "react";
import { DOCUMENT_TYPES } from "../document-types.js";
import { AddNewIcon } from "../icons/AddNewIcon.js";
import { AppIcon } from "../icons/AppIcon.js";
import { DocModelIcon } from "../icons/DocModelIcon.js";
import { EditorIcon } from "../icons/EditorIcon.js";
import { ProcessorIcon } from "../icons/ProcessorIcon.js";
import { SubgraphIcon } from "../icons/SubgraphIcon.js";
interface ModuleItemProps {
  fileNode: FileNode;
  onClick: (file: FileNode) => void;
  onDelete?: (file: FileNode) => void;
  className?: string;
}

const getIconForDocumentType = (documentType: string) => {
  switch (documentType) {
    case DOCUMENT_TYPES.documentModel:
      return DocModelIcon;
    case DOCUMENT_TYPES.documentEditor:
      return EditorIcon;
    case DOCUMENT_TYPES.documentSubgraph:
      return SubgraphIcon;
    case DOCUMENT_TYPES.documentProcessor:
      return ProcessorIcon;
    case DOCUMENT_TYPES.documentApp:
      return AppIcon;
    case "new":
      return AddNewIcon;
    default:
      return DocModelIcon;
  }
};

export const ModuleItem: React.FC<ModuleItemProps> = ({
  fileNode,
  onClick,
  onDelete,
  className = "",
}) => {
  const IconComponent = getIconForDocumentType(fileNode.documentType);
  const [isDropdownMenuOpen, setIsDropdownMenuOpen] = useState(false);

  // Only show DELETE option
  const dropdownMenuOptions = [
    {
      ...fileNodeDropdownOptions.DELETE,
      id: "DELETE" as const,
    },
  ];

  const dropdownMenuHandlers = {
    DELETE: () => onDelete?.(fileNode),
  } as const;

  function onDropdownMenuOptionClick(
    itemId: keyof typeof dropdownMenuHandlers,
  ) {
    const handler = dropdownMenuHandlers[itemId];

    handler();
    setIsDropdownMenuOpen(false);
  }

  return (
    <div
      onClick={() => onClick(fileNode)}
      className={twMerge(
        "group flex w-full cursor-pointer items-center gap-3 rounded-md bg-muted p-1 text-left transition-colors hover:hover-effect",
        className,
      )}
    >
      <div className="shrink-0">
        {/* eslint-disable-next-line react-hooks/static-components */}
        <IconComponent />
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="truncate text-sm font-medium text-foreground">
          {fileNode.name}
        </h3>
        <p className="truncate text-xs text-muted-foreground">
          {fileNode.documentType}
        </p>
      </div>
      {onDelete ? (
        <ConnectDropdownMenu
          items={dropdownMenuOptions}
          onItemClick={onDropdownMenuOptionClick}
          onOpenChange={setIsDropdownMenuOpen}
          open={isDropdownMenuOpen}
          menuClassName="border-border"
        >
          <button
            className={twMerge(
              "hidden group-hover:block",
              isDropdownMenuOpen && "block",
            )}
            onClick={(e) => {
              e.stopPropagation();
              setIsDropdownMenuOpen(true);
            }}
          >
            <Icon className="text-foreground" name="VerticalDots" />
          </button>
        </ConnectDropdownMenu>
      ) : null}
    </div>
  );
};
